// extracted by css-extract-rspack-plugin
var _1 = "C52d4gMOnUYwe05I";
export { _1 as "cardWrapperStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "C52d4gMOnUYwe05I";
export { _1 as "cardWrapperStyle" }
